import Skeleton from "react-loading-skeleton";

const SkeletonVideoCard = () => {
    // Get theme from localStorage (default to 'light' if not set)
    const theme = localStorage.getItem("theme") || "light";

    // Define colors for light and dark themes
    const skeletonColors = theme === "dark"
        ? { baseColor: "#23272F", highlightColor: "#3A3F4B" }
        : { baseColor: "#CECECE", highlightColor: "#E8E8E8" };

    return (
        <div className="grid grid-cols-3 gap-1 p-2 overflow-scroll no-scrollbar">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((data) => (
                <div
                    key={data}
                    className="col-span-1 w-full h-[45vw] md:h-[9vw]"
                >
                    <Skeleton
                        {...skeletonColors}
                        width="100%"
                        height="100%"
                        style={{ borderRadius: "0.5rem" }}
                    />
                </div>
            ))}
        </div>
    )
}

export default SkeletonVideoCard